import React, { useEffect, useState } from "react";
import TodoHistory from "./TodoHistory";

export default function TodoDetails({ todo, handleExpireTodo }) {
  const [showDetails, setShowDetails] = useState(true);
  const [showHistory, setShowHistory] = useState(false);

  function toggleHistory() {
    setShowHistory(!showHistory);
  }

  return (
    <div data-testid="todoDetails" style={{ textAlign: "right" }}>
      <div>
        <button
          data-testid="historyButton"
          className="btn btn-xs btn-link"
          onClick={toggleHistory}
        >
          {showHistory ? "Close History" : "Show History"}
        </button>
        <button
          className="btn btn-xs btn-link"
          onClick={() => {
            handleExpireTodo(todo.id);
          }}
        >
          Delete
        </button>
      </div>
      {showHistory && (
        <TodoHistory
          todo={todo}
          showHistory={showHistory}
          showDetails={showDetails}
        />
      )}
    </div>
  );
}
